import React from "react";

const ModalInfo = ({ message, txtBtnValid, txtBtnCancel, onValid, onCancel }) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <p style={styles.message}>{message}</p>

        <div style={styles.buttons}>
          <button style={{ ...styles.btn, ...styles.cancel }} onClick={onCancel}>
            {txtBtnCancel}
          </button>
          <button style={{ ...styles.btn, ...styles.valid }} onClick={onValid}>
            {txtBtnValid}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999
  },
  modal: {
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "10px",
    maxWidth: "400px",
    width: "90%",
    textAlign: "center",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
  },
  message: {
    marginBottom: "20px",
    fontSize: "16px",
    color: "#333"
  },
  buttons: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px"
  },
  btn: {
    flex: 1,
    padding: "10px 0",
    fontSize: "15px",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer"
  },
  valid: {
    backgroundColor: "#4CAF50",
    color: "#fff"
  },
  cancel: {
    backgroundColor: "#f44336",
    color: "#fff"
  }
};

export default ModalInfo;
